import { Image, StyleSheet, Text, View } from '@react-pdf/renderer';

import AIReviewBackground from '@/assets/images/ai-review-bg.png';
import Tick from '@/assets/images/tick.png';

type ReportSectionItemProps = {
  title: string;
  point?: number;
  pluses: Array<string> | undefined;
};

export const ReportSectionItemPdf: React.FC<ReportSectionItemProps> = (
  props
) => {
  return (
    <View style={style.container}>
      <View style={style.headingContainer}>
        <Text style={style.title}>{props.title}</Text>
        <View style={style.progressBar}>
          <View>
            <ProgressBar progress={props.point ?? 0} />
          </View>
          <Text>{props.point?.toPrecision(2)}%</Text>
        </View>
      </View>
      <View>
        <Image src={AIReviewBackground} style={style.reviewBg} />
        <View style={style.reviewGradientContainer}>
          <View style={style.reviewGradientBox}>
            {props.pluses?.map((plus) => (
              <View style={style.reviewGradient} key={plus}>
                <View style={style.tick}>
                  <Image
                    src={Tick}
                    style={{ width: 6, height: 5, zIndex: 99 }}
                  />
                </View>
                <Text style={style.review} key={plus}>
                  {plus}
                </Text>
              </View>
            ))}
          </View>
        </View>
      </View>
    </View>
  );
};

const style = StyleSheet.create({
  container: {
    position: 'relative',
    borderRadius: 8,
    spacing: 0,
    borderWidth: '1px',
    borderColor: '#F1F2F2',
    marginTop: 10,
  },
  headingContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    paddingX: 8,
    paddingY: 8,
    height: 43,
    alignItems: 'center',
    flexDirection: 'row',
    marginHorizontal: 15,
  },
  title: {
    fontSize: 12,
  },
  reviewGradient: {
    fontWeight: 600,
    margin: 5,
    fontSize: 14,
    direction: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    flexDirection: 'row',
    display: 'flex',
    columnGap: 5,
  },
  review: {
    my: 2,
    alignItems: 'center',
    fontSize: 10,
  },
  reviewBg: {
    position: 'absolute',
    minWidth: '100%',
    minHeight: '100%',
    height: '100%',
    width: '100%',
    borderBottomLeftRadius: 7,
    borderBottomRightRadius: 7,
  },
  reviewGradientContainer: {
    padding: 10,
  },
  progressBar: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    columnGap: 10,
    color: '#18BF88',
    fontSize: 12,
  },
  reviewGradientBox: {
    borderRadius: 8,
    borderColor: '#E0F9ED',
    borderWidth: 1,
    backgroundColor: 'white',
    padding: 8,
  },
  tick: {
    width: 12,
    height: 12,
    backgroundColor: '#18BF88',
    borderRadius: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
});

type ProgressBarProps = {
  progress: number;
};

const ProgressBar: React.FC<ProgressBarProps> = ({ progress }) => {
  return (
    <View style={progressStyles.progressBarContainer}>
      <View
        style={{
          ...progressStyles.progressBar,
          width: `${progress}%`,
          backgroundColor: '#4CAF50',
        }}
      />
    </View>
  );
};

const progressStyles = StyleSheet.create({
  progressBarContainer: {
    width: 100,
    backgroundColor: '#E0E0E0',
    borderRadius: 5,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    position: 'relative',
    height: 5,
    overflow: 'hidden',
  },
  progressBar: {
    height: '100%',
    borderRadius: 5,
    position: 'absolute',
    left: 0,
    top: 0,
  },
});
